import { render, staticRenderFns } from "./prdAnalise.vue?vue&type=template&id=71464cc3&scoped=true&"
import script from "./prdAnalise.vue?vue&type=script&lang=js&"
export * from "./prdAnalise.vue?vue&type=script&lang=js&"
import style0 from "./prdAnalise.vue?vue&type=style&index=0&id=71464cc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71464cc3",
  null
  
)

export default component.exports